import React, { useState } from "react";

const SpotOrder = () => {
  const [activeTab, setActiveTab] = useState("Open Orders");
  const [filter, setFilter] = useState("All");
  const [pair, setPair] = useState("All");
  const [direction, setDirection] = useState("All");

  return (
    <div className="p-6">
      {/* Tabs */}
      <div className="flex space-x-6 border-b border-gray-200">
        {["Open Orders", "Order History", "Trade History"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`pb-2 text-sm font-medium ${
              activeTab === tab
                ? "text-black border-b-2 border-yellow-500"
                : "text-gray-500"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="flex space-x-4 mt-4">
        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border rounded-md px-3 py-2 text-sm" 
          
        >
          <option>All</option>
          <option>Limit</option>
          <option>Market</option>
        </select>

        <select
          value={pair}
          onChange={(e) => setPair(e.target.value)}
          className="border rounded-md px-3 py-2 text-sm"
        >
          <option>All</option>
          <option>BTC/USDT</option>
          <option>ETH/USDT</option>
        </select>

        <select
          value={direction}
          onChange={(e) => setDirection(e.target.value)}
          className="border rounded-md px-3 py-2 text-sm"
        >
          <option>All</option>
          <option>Buy</option>
          <option>Sell</option>
        </select>
      </div>

      {/* Table */}
      <div className="mt-6 relative overflow-x-auto">
        <table className="w-full text-sm text-left text-gray-600">
          <thead className="border-b text-gray-500">
            <tr>
              <th className="px-4 py-2">Date</th>
              <th className="px-4 py-2">Pair</th>
              <th className="px-4 py-2">Type</th>
              <th className="px-4 py-2">Side</th>
              <th className="px-4 py-2">Price</th>
              <th className="px-4 py-2">Amount</th>
              <th className="px-4 py-2">Amount per Iceberg Order</th>
              <th className="px-4 py-2">Filled</th>
              <th className="px-4 py-2">Total</th>
              <th className="px-4 py-2">Trigger Conditions</th>
              <th className="px-4 py-2">TP/SL</th>
              <th className="px-4 py-2 text-yellow-600 cursor-pointer">
                Cancel All
              </th>
            </tr>
          </thead>
          <tbody>
            {/* Empty state */}
            <tr>
              <td colSpan="12" className="text-center py-20">
                <div className="flex flex-col items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-10 w-10 text-gray-400 mb-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={1.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                  <p className="text-gray-400 text-sm">No records found.</p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SpotOrder;
